function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _$;
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import barba from '@barba/core';
var textTyper;
var arrBrands = ['iPhone XS max', 'Samsung A51', 'Huawei P40 pro', 'Honor 20', 'Xiaomi MI 9', 'Oppo A52', 'Vivo Y31'];
var words = 0;
var defText = (_$ = $('.search__string__input')) === null || _$ === void 0 ? void 0 : _$.placeholder;
var dataSearch = [];
function liveSearch() {
  var count = 0;
  var liveListCard = $(".search__cards__list");
  var inputText = $('.search__string__input').value.trim().toUpperCase();
  liveListCard.innerHTML = "";
  if (inputText !== "") {
    $('.search__cards').classList.add('active');
    $(".clear__search").style.display = "flex";
  } else {
    $('.search__cards').classList.remove('active');
    $(".clear__search").style.display = "none";
  }
  var dataRelivant = dataSearch.sort(function (a, b) {
    return b.views - a.views;
  });
  dataRelivant.forEach(function (elem) {
    var title = elem.title !== undefined ? elem.title.toUpperCase().trim() : "";
    var titleAlt = elem.atitle !== undefined ? elem.atitle.toUpperCase().trim() : "";
    if (title.includes(inputText) || titleAlt.includes(inputText)) {
      var searchCardItem = document.createElement("a");
      searchCardItem.href = elem.url;
      searchCardItem.classList.add("search__cards__item");
      sound_hover(searchCardItem);
      searchCardItem.innerHTML = "<strong>".concat(elem.title || elem.atitle, "</strong>");
      liveListCard.appendChild(searchCardItem);
      count++;
      $(".search__cards__info").textContent = "\u041D\u0430\u0439\u0434\u0435\u043D\u043E - ".concat(count, " \u0441\u0442\u0440\u0430\u043D\u0438\u0446(\u044B)");
    }
    if (count === 0) $('.search__cards__info').textContent = "\u041D\u0438\u0447\u0435\u0433\u043E \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u043E";
  });
}
export var SearchModel = /*#__PURE__*/function () {
  function SearchModel() {
    _classCallCheck(this, SearchModel);
  }
  return _createClass(SearchModel, [{
    key: "submit",
    value: function submit(value) {
      barba.go("/poisk?s=".concat(value));
    }
  }, {
    key: "open",
    value: function open() {
      var _this = this;
      $('body').classList.add('overflow__hidden');
      console.log($$('.search__form'));
      $('.search__form').onsubmit = function (e) {
        e.preventDefault();
        _this.submit($(".search__string__input").value);
      };
      var tl = gsap.timeline();
      tl.fromTo('.search__form', {
        display: "block",
        opacity: 0
      }, {
        duration: .5,
        opacity: 1,
        onComplete: function onComplete() {
          TypeTextKey(arrBrands[words]);
        }
      }).from('.search__string', {
        duration: .5,
        y: -50
      }, .15);
      $('.search__string__input').focus();
      function TypeTextKey(text) {
        $('.search__string__input').placeholder = defText;
        var textForType = "  - ".concat(text);
        var index = 0;
        textTyper = setInterval(function () {
          if (index === textForType.length - 1) {
            clearInterval(textTyper);
            words++;
            if (words < arrBrands.length - 1) TypeTextKey(arrBrands[words]);else {
              $('.search__string__input').placeholder = defText;
              words = 0;
            }
          } else $('.search__string__input').placeholder += textForType[index + 1];
          index++;
        }, 150);
      }
      $('.search__form__close').addEventListener('click', function (e) {
        return _this.close();
      });
      this.liveStart();
    }
  }, {
    key: "close",
    value: function close() {
      clearInterval(textTyper);
      words = 0;
      var tl = gsap.timeline();
      $('body').classList.remove('overflow__hidden');
      tl.fromTo('.search__form', {
        opacity: 1
      }, {
        duration: .2,
        opacity: 0,
        display: "none"
      });
      this.clear();
    }
  }, {
    key: "liveStart",
    value: function liveStart() {
      var _this2 = this;
      if (sessionStorage.getItem("search-data") === null) {
        $('.search__cards__info').textContent = "\u0418\u0434\u0451\u0442 \u0437\u0430\u0433\u0440\u0443\u0437\u043A\u0430...";
        axios.get("search").then(function (r) {
          sessionStorage.setItem("search-data", JSON.stringify(r.data));
          dataSearch = r.data;
          liveSearch();
        })["catch"](function (r) {
          cPush.show({
            title: "\u041E\u0448\u0438\u0431\u043A\u0430 \u043F\u0440\u0438 \u0437\u0430\u0433\u0440\u0443\u0437\u043A\u0435 \u0434\u0430\u043D\u043D\u044B\u0445.",
            text: r
          });
        });
      } else dataSearch = JSON.parse(sessionStorage.getItem("search-data"));
      $(".clear__search").onclick = function () {
        return _this2.clear();
      };
      $('.search__string__input').oninput = function (e) {
        return liveSearch();
      };
    }
  }, {
    key: "clear",
    value: function clear() {
      $(".search__string__input").value = "";
      $(".search__cards__list").innerHTML = "";
      $('.search__cards').classList.remove('active');
      $(".clear__search").style.display = "none";
    }
  }]);
}();